import React from 'react';
import { MediaPlaceholder } from './MediaPlaceholder';
const modules = [{
  title: 'MÓDULO 1: FUNDAMENTOS UGC',
  desc: 'Aprende las bases, qué buscan las marcas y cómo estructurar tu mentalidad para el éxito.'
}];
export function ModulesSection() {
  return <section className="px-6 py-12 flex flex-col items-center text-center mt-[-70px] mb-[-70px] max-w-7xl mx-auto" data-id="element-145"></section>;
}